import { game } from '../main';
import { GameGrid } from './GameGrid';
import { changeTexture } from '../utils/changeTexture';
import { stopTweens } from '../utils/stopTweens';


export class Bubble extends Phaser.Sprite {
  public signals = {
    onBounceFinished: new Phaser.Signal(),
  };

  private grid: GameGrid;
  public collCircle: Phaser.Circle = new Phaser.Circle(0, 0 ,0);
  public bubbleType: number;
  public typeName: string;
  public checked: boolean;
  public cellX: number;
  public cellY: number;
  public orgX: number;
  public orgY: number;
  private duringBounce: boolean = false;
  public velX: number;
  public velY: number;
  private pullX: number;
  private pullY: number;
  public pointsAfterBurst: number;

  private scaleBounceTween: Phaser.Tween;

  constructor(grid: GameGrid) {
    super(game, 0, 0);

    this.anchor.setTo(0.5);
    this.grid = grid;
    this.kill();
  }

  private basicInit(cx: number, cy: number, x: number, y: number, type: number): void {
    stopTweens(this);
    this.alpha = 1;
    this.scale.setTo(1);
    this.angle = 0;

    this.orgX = x;
    this.orgY = y;

    this.pullX = 0;
    this.pullY = 0;

    this.cellX = cx;
    this.cellY = cy;
    this.duringBounce = false;

    this.collCircle.setTo(x, y, 50);

    this.checked = false;

    this.position.set(x, y);

    this.revive();
  }

  public initRegular(cx: number, cy: number, x: number, y: number, type: number): void {
    this.basicInit(cx, cy, x, y, type);
    changeTexture(this, game.config.skinId + '_bubble_' + game.config.bubbleNames[type]);
    this.bubbleType = type;
    this.typeName = game.config.bubbleNames[type];
  }

  public checkType(type: number) {
    if (this.checked) {
      return false;
    } else {
      this.checked = true;
      return this.isMatchingType(type);
    }
  }

  public clearCheck(): void {
    this.checked = false;
  }

  public update(): void {
    if (!this.alive) return;
    if (this.duringBounce) this.bounceUpdate();
  }

  public isMatchingType(type: number): boolean {
    return this.bubbleType === type;
  }

  private startBounce(velX: number, velY: number): void {
    this.duringBounce = true;
    this.velX = velX;
    this.velY = velY;

    this.scaleBounceTween = game.add.tween(this.scale)
      .to({
        x: 0.9,
        y: 0.9
      }, 100, Phaser.Easing.Elastic.InOut, true, 0, 0, true);
  }

  private bounceUpdate(): void {
    if (this.duringBounce && this.alive) {
      this.x += this.velX;
      this.y += this.velY;
      this.velX *= 0.9;
      this.velY *= 0.9;

      this.pullX = (this.x - this.orgX) * -0.6;
      this.pullY = (this.y - this.orgY) * -0.6;
      this.x += this.pullX;
      this.y += this.pullY;

      if (!this.scaleBounceTween.isRunning && Math.abs(this.x - this.orgX) < 1 && Math.abs(this.y - this.orgY) < 1) {
        this.x = this.orgX;
        this.y = this.orgY
        this.duringBounce = false;
        this.signals.onBounceFinished.dispatch();
      }

    }
  }
}
